
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelSouth as ObiBuoyBarrelSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-south.js';
 
 
 

 
 export const ObiBuoyBarrelSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-south',
   elementClass: ObiBuoyBarrelSouthElement,
   events: {
     
   }
  });
 
 